/**
 * Для психолога в групповой терапии: отфильтровать список видео,
 * исключив участников, которые ещё в ожидании (запросили подключение, но не на встрече).
 */
export function filterVideosByAwaiting<T extends { identity?: string; display?: string }>(
  videos: T[],
  awaitingIdentities: string[],
): T[] {
  if (awaitingIdentities.length === 0) return videos;
  const set = new Set(awaitingIdentities);
  return videos.filter((v) => {
    const id = v.identity ?? v.display ?? '';
    return !set.has(id);
  });
}
